// extracted by mini-css-extract-plugin
export var chip = "_9p-0";
export var filterDropdown = "_9p-5";
export var filterItem = "_9p-6";
export var icon = "_9p-1";
export var removeButton = "_9p-3";
export var removeIcon = "_9p-4";
export var separator = "_9p-2";